export default __webpack_public_path__ + "static/information-security-d74515e1ca2294f52eabcb528b16c542.png";